import { combineReducers, AnyAction, Reducer } from "redux";
import { Props as ProjectListItemProps } from "../components/ProjectListItem";
import State from "../types/State";
import * as actionTypes from "./actionTypes";

const loadingReducer: Reducer<boolean> = (state: boolean = false, action: AnyAction) => {
  switch (action.type) {
    case actionTypes.PROJECT_LIST_SET_LOADING: {
      return action.payload;
    }
    default:
      return state;
  }
};

const projectsReducer: Reducer<ProjectListItemProps[]> = (state: ProjectListItemProps[] = [], action: AnyAction) => {
  switch (action.type) {
    case actionTypes.PROJECT_LIST_SET_PROJECTS: {
      return action.payload;
    }
    default:
      return state;
  }
};

export default combineReducers<State>({
  loading: loadingReducer,
  projects: projectsReducer
});
